import { Link } from "react-router-dom";

const TradingCalculatorContentThree = () => {
  return (
    <div className="how__work__resource">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="content-left">
              <h2>Trade with Data-Driven Confidence</h2>
              <p>
                Success in trading begins with preparation. With The Pips
                Trading Calculator, you can evaluate every trade before
                execution, ensuring each decision aligns with your strategy and
                risk tolerance. It gives you a clear breakdown of potential
                outcomes, so you can anticipate market movements instead of
                reacting to them. By understanding your margin, pip value, and
                projected profit or loss upfront, you eliminate uncertainty and
                avoid unnecessary risks. The tool also helps you fine-tune your
                position sizes to match volatile or stable market conditions.
                With precise data guiding your decisions, you trade with greater
                consistency, discipline, and confidence.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Try It Now
              </Link>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="thumb-right">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/resources/trading_calculator/trading_calculator_3.png"
                }
                alt="computer images"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TradingCalculatorContentThree;
